import '../css/main.css'

import { createPinia } from 'pinia'
import { createApp, h } from 'vue'
import { createInertiaApp } from '@inertiajs/vue3'
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers'
import { ZiggyVue } from 'ziggy-js';

const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Growiyo'
const pinia = createPinia()

createInertiaApp({
    //title: (title) => `${title} - ${appName}`, // TODO title not working
    resolve: (name) =>
        resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
    async setup({ el, App, props, plugin }) {
        const app = createApp({
            render: () => h(App, props),
        })
            .use(plugin)
            .use(pinia)
            .use(ZiggyVue, Ziggy)

        // Vuetify is only used by Admin (+ shared admin components). Skip it on the public site.
        const component = props.initialPage?.component ?? ''
        if (component.startsWith('Admin/')) {
            const { default: vuetify } = await import('./vuetify')
            app.use(vuetify)
        }

        app.mount(el)
    },
    progress: {
        color: '#4B5563'
    },
})
